import { render, staticRenderFns } from "./FeaturedOffers.vue?vue&type=template&id=0f4b8de7&lang=pug&"
import script from "./FeaturedOffers.vue?vue&type=script&lang=js&"
export * from "./FeaturedOffers.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedOffers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f4b8de7')) {
      api.createRecord('0f4b8de7', component.options)
    } else {
      api.reload('0f4b8de7', component.options)
    }
    module.hot.accept("./FeaturedOffers.vue?vue&type=template&id=0f4b8de7&lang=pug&", function () {
      api.rerender('0f4b8de7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/featured-offers/FeaturedOffers.vue"
export default component.exports